<script setup lang="ts">
import { UIModal, UIModalHeader, UIModalFooter } from '@gohighlevel/ghl-ui'
import { Trash01Icon } from '@gohighlevel/ghl-icons/24/outline'

const props = defineProps({
  show: Boolean,
  headerTitle: String,
  disabledConfirm: Boolean,
})

const emit = defineEmits(['onConfirm', 'onModalClose', 'update:show'])

const handleSave = () => {
  emit('onConfirm')
}
const handleCancel = () => {
  emit('onModalClose')
}
</script>

<template>
  <UIModal
    id="deleteConfirmationModal"
    :show="show"
    @update:show="val => $emit('update:show', val)"
  >
    <template #header>
      <UIModalHeader
        id="deleteConfirmationModalHeader"
        type="error"
        :title="headerTitle"
        :icon="Trash01Icon"
        @close="handleCancel"
      >
      </UIModalHeader>
    </template>

    <slot name="message" />

    <template #footer>
      <UIModalFooter
        id="deleteConfirmationModalFooter"
        type="error"
        :positive-text="$t('settings.calendar.delete_group')"
        :negative-text="$t('settings.calendar.cancel')"
        :loading="disabledConfirm"
        :disabled="disabledConfirm"
        @positive-click="handleSave"
        @negative-click="handleCancel"
      />
    </template>
  </UIModal>
</template>
